<div class="row mt-12">
<div class="col-md-12 p-1">
  <span>Geo Code </span>
  <label class="mx-3 ml-4"> lat: {{lat}}, lng: {{lng}} </label>

  <google-map [center]="{lat: lat, lng: lng}" [zoom]="zoom" (mapClick)="mapClicked($event)">
    <map-marker [position]="{lat: lat, lng: lng}" [options]="{animation: animation === 'DROP' ? 2 : (animation === 'BOUNCE' ? 1 : null)}" (mapMouseover)="markerOver()"
                (mapMouseout)="markerOut()"></map-marker>
  </google-map>
</div>
  </div>
